import { BlueButton } from 'pages/NotifyEvent/styles'
import React from 'react'
import { IoCloseSharp } from 'react-icons/io5'


interface IAnonymousInfoModal {
  close: () => void
}
export default function AnonymousInfoModal({ close }: IAnonymousInfoModal) {
  return (
    <div data-testid="test-anonymous-modal" className='md:text-center text-left md:px-14 md:py-10 md:w-[565px]'>
      <div className='flex items-center'>
        <div className='text-center flex  w-full md:justify-center'>
          <p className='text-xl font-semibold text-yellow'>Você escolhe</p>
        </div>
        <div
          className='ml-auto cursor-pointer'
          data-testid="test-close-info-modal"
          onClick={close}
        >
          <IoCloseSharp
            className="text-blueTheme h-8 w-8 p-1 cursor-pointer "
          />
        </div>
      </div>
      <p className='text-darkGray mt-3 md:text-base text-xs'>A sua notificação pode ser anônima, e isso garante
        100% da confiabilidade de que não teremos como
        rastrear a origem dela. Caso você queira se identificar,
        apenas o seu nome completo ficará registrado.</p>
      <div className='mt-8 flex justify-center'>
        <BlueButton
          onClick={() => {
            close()
          }}
          className="w-[210px]"
        >
          Ok
        </BlueButton>
      </div>
    </div>
  )
}
